import { gql } from 'apollo-boost';
import { useMutation } from '../';

const mutation = gql`
  mutation deleteContributionViews($id: Int!) {
    deleteContributionViews(id: $id) {
      success
    }
  }
`;

export function useDeleteContributionViews() {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    mutate(mutation, variables, () => {
      if (typeof onFinish === 'function') {
        onFinish();
      }
    });
  };
  return { data, isLoading, run };
}
